import { actionCreator } from 'utils';
import { 
    ADD_NEW_PROMOTION,
    LOAD_PROMOTIONS,
    SET_PROMOTION_FILTER,
    SET_PROMOTION_PAGINATION,
    SET_PROMOTION_SORT,
    RESET_PROMOTION_FILTERS,
    LOAD_EDITABLE_PROMOTION,
    SET_EMPTY_EDITABLE_PROMOTION,
    LOAD_SELL_PRICES_FOR_PROMOTION,
    EDIT_PROMOTION,
    SET_SELL_PRICES_PAGINATION,
    SET_PROMOTION_SELL_PRICES_FILTER,
    SET_PROMOTION_SELL_PRICES_SORT,
    RESET_PROMOTION_SELL_PRICES_FILTERS,
    SET_EMPTY_SELL_PRICES,
    SAVE_PROMO_TO_CUSTOMIZE,
    SET_EMPTY_PROMO_TO_CUSTOMIZE,
    ATTACH_SELLPRICES_TO_PROMOTION,
    LOAD_PROMOTION_SELLPRICES,
    UPDATE_SELL_PRICES,
    DELETE_SELL_PRICES,
    SET_PROMO_SELL_PRICES_FILTER,
    SET_PROMO_SELL_PRICES_PAGINATION,
    RESET_PROMO_SELL_PRICES_FILTERS,
} from '../types/promotionTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    limit: 10,
    offset: 0,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        'title.translate': '',
        resellers: [],
        crossed: undefined,
        start_date: [],
        end_date: [],
    },
    resellers: {
        loading: false,
        error: false,
        listing: [],
    },
    sellPrices: {
        loading: false,
        error: false,
        offset: 0,
        limit: 10,
        listing: [],
        filters: {
            'configuration_property.carrier_id': [],
            'configuration_property.property_value_id': [],
            configuration_type: [],
            'name.translate': '',
        },
        sort: {
            key: 'created_at',
            type: 'desc',
        },
    },
    add: {
        loading: false,
        error: false,
        success: false,
    },
    edit: {
        loading: false,
        error: false,
        data: null,
    },
    customize: {
        loading: false,
        error: false,
        data: null,
    },
    attach: {
        loading: null,
        error: false,
        success: false,
    },
    promoSellPrices: {
        loading: false,
        error: false,
        limit: 10,
        offset: 0,
        listing: null,
        update: {
            loading: [],
            error: false,
            success: false,
        },
        delete: {
            loading: [],
            error: false,
            success: false,
        },
        filters: {
            resellers: [],
            productGroup: [],
        },
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case ADD_NEW_PROMOTION:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ADD_NEW_PROMOTION, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(ADD_NEW_PROMOTION, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case LOAD_PROMOTIONS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_PROMOTIONS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_PROMOTIONS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_PROMOTION_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_PROMOTION_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case SET_PROMOTION_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_PROMOTION_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case RESET_PROMOTION_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case LOAD_EDITABLE_PROMOTION:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITABLE_PROMOTION, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITABLE_PROMOTION, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: action.error,
            }),
        });

    case SET_EMPTY_EDITABLE_PROMOTION:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                data: null,
            }),
        });

    case LOAD_SELL_PRICES_FOR_PROMOTION:
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_SELL_PRICES_FOR_PROMOTION, 'res'):
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(LOAD_SELL_PRICES_FOR_PROMOTION, 'err'):
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                error: true,
                loading: false,
            }),
        });

    case SET_SELL_PRICES_PAGINATION:
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                [action.key]: action.pagination,
            }),
        });

    case EDIT_PROMOTION:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(EDIT_PROMOTION, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
                data: Object.assign({}, state.edit.data, {
                    sell_prices: [],
                }),
            }),
        });

    case actionCreator(EDIT_PROMOTION, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case SET_PROMOTION_SELL_PRICES_FILTER:
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                loading: true,
                filters: {
                    ...state.sellPrices.filters,
                    [action.key]: action.value,
                },
            }),
        });

    case actionCreator(SET_PROMOTION_SELL_PRICES_FILTER, 'res'):
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                loading: false,
                listing: action.data,
            }),
        });

    case SET_PROMOTION_SELL_PRICES_SORT:
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                sort: action.sort,
            }),
        });

    case RESET_PROMOTION_SELL_PRICES_FILTERS:
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                filters: initState.sellPrices.filters,
            }),
        });

    case SET_EMPTY_SELL_PRICES:
        return Object.assign({}, state, {
            sellPrices: Object.assign({}, state.sellPrices, {
                listing: [],
            }),
        });

    case actionCreator(SAVE_PROMO_TO_CUSTOMIZE, 'res'):
        return Object.assign({}, state, {
            customize: Object.assign({}, state.customize, {
                loading: false,
                data: action.data,
            }),
        });

    case SET_EMPTY_PROMO_TO_CUSTOMIZE:
        return Object.assign({}, state, {
            customize: Object.assign({}, state.customize, {
                data: null,
            }),
        });

    case ATTACH_SELLPRICES_TO_PROMOTION:
        return Object.assign({}, state, {
            attach: Object.assign({}, state.attach, {
                loading: action.data.sell_price_id,
                error: false,
            }),
        });

    case actionCreator(ATTACH_SELLPRICES_TO_PROMOTION, 'res'):
        return Object.assign({}, state, {
            attach: Object.assign({}, state.attach, {
                loading: null,
                success: action.success,
            }),
        });

    case actionCreator(ATTACH_SELLPRICES_TO_PROMOTION, 'err'):
        return Object.assign({}, state, {
            attach: Object.assign({}, state.attach, {
                loading: null,
                success: false,
                error: action.error,
            }),
        });

    case LOAD_PROMOTION_SELLPRICES:
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_PROMOTION_SELLPRICES, 'res'):
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(LOAD_PROMOTION_SELLPRICES, 'err'):
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                error: true,
                loading: false,
            }),
        });

    case UPDATE_SELL_PRICES:
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                update: Object.assign({}, state.promoSellPrices.update, {
                    loading: [
                        ...state.promoSellPrices.update.loading,
                        ...action.data[0].sell_prices.map(s => s.sell_price_id),
                    ],
                    error: false,
                }),
            }),
        });

    case actionCreator(UPDATE_SELL_PRICES, 'res'):
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                update: {
                    ...state.promoSellPrices.update,
                    loading: state.promoSellPrices.update.loading.filter(c => !action.payload.includes(c)),
                    success: true,
                },
            }),
        });

    case actionCreator(UPDATE_SELL_PRICES, 'err'):
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                update: Object.assign({}, state.promoSellPrices.update, {
                    error: true,
                    loading: [],
                }),
            }),
        });

    case DELETE_SELL_PRICES:
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                delete: Object.assign({}, state.promoSellPrices.delete, {
                    loading: [
                        ...state.promoSellPrices.delete.loading,
                        action.data[0].sell_price_id,
                    ],
                    error: false,
                }),
            }),
        });

    case actionCreator(DELETE_SELL_PRICES, 'res'):
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                delete: {
                    ...state.promoSellPrices.delete,
                    loading: state.promoSellPrices.delete.loading.filter(c => !action.payload.includes(c)),
                    success: true,
                },
            }),
        });

    case actionCreator(DELETE_SELL_PRICES, 'err'):
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                delete: Object.assign({}, state.promoSellPrices.delete, {
                    error: true,
                    loading: [],
                }),
            }),
        });

    case SET_PROMO_SELL_PRICES_FILTER:
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                filters: {
                    ...state.promoSellPrices.filters,
                    [action.key]: action.value,
                },
            }),
        });

    case SET_PROMO_SELL_PRICES_PAGINATION:
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                [action.key]: action.pagination,
            }),
        });

    case RESET_PROMO_SELL_PRICES_FILTERS:
        return Object.assign({}, state, {
            promoSellPrices: Object.assign({}, state.promoSellPrices, {
                filters: initState.promoSellPrices.filters,
            }),
        });

    default:
        return state;
    }
}
